<template>
  <div class="content-box" :style="bgStyle">
    <el-select v-if="i18n.enable" v-model="loginForm.locale" class="lang" @change="langChange">
      <el-option v-for="locale in i18n.localeList" :key="locale.value" :value="locale.value" :label="locale.label"></el-option>
    </el-select>
    <el-form ref="loginForm" class="login-form" :model="loginForm" :rules="loginFormRules">
      <div class="title">{{ $store.getters['core/getAppName'] || $t('Login.title') }}</div>
      <el-form-item prop="userName">
        <el-input prefix-icon="el-icon-user" size="large" v-model="loginForm.userName" :placeholder="$t('Login.userName')" @keyup.enter="login"></el-input>
      </el-form-item>
      <el-form-item prop="inputPassword">
        <el-input prefix-icon="el-icon-key" size="large" v-model="loginForm.inputPassword" :placeholder="$t('Login.password')" show-password @keyup.enter="login"></el-input>
      </el-form-item>
      <el-form-item prop="verifyCode">
        <el-col :span="17">
          <el-input prefix-icon="el-icon-key" size="large" v-model="loginForm.verifyCode" :placeholder="$t('Login.verifyCode')" @keyup.enter="login"></el-input>
        </el-col>
        <el-col class="code-box" :span="7">
          <img class="code-img" :src="verifyImgSrc" @click="createCode">
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button class="login-btn" :loading="loading" size="large" type="primary" @click="login">{{ $t('Login.login') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        locale: '',
        userName: '',
        inputPassword: '',
        verifyCode: '',
        verifyId: '',
      },
      loading: false,
      verifyImgSrc: '',
      loginFormRules: {
        userName: [
          {required: true, message: this.$t('Login.userName'), trigger: 'blur'}
        ],
        inputPassword: [
          {required: true, message: this.$t('Login.password'), trigger: 'blur'}
        ],
        verifyCode: [
          {required: true, message: this.$t('Login.verifyCode'), trigger: 'blur'}
        ],
      }
    }
  },
  computed: {
    i18n() {
      return this.$store.state.core.i18n
    },
    bgStyle() {
      let obj = {
        background: 'url(' + this.$store.state.wallpaper.loginWallpaper + ')',
        backgroundSize: 'auto auto'
      };
      if (this.$store.state.wallpaper.isBig) {
        obj.backgroundSize = '100% 100%'
      }
      return obj;
    }
  },
  methods: {
    login() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) {
          return
        }

        this.loading = true;
        this.$http('frameLoginService.login', this.loginForm, false).then(data => {
          this.loading = false;
          localStorage.setItem('token', data)
          this.$router.push('desktop?v=' + new Date().getTime())
        }, errMsg => {
          this.loading = false;
          this.createCode();
          return this.$message.error(errMsg);
        })

      })
    },
    async createCode() {
      let data = await this.$http('frameLoginService.getCaptcha')
      this.loginForm.verifyId = data.id;
      this.verifyImgSrc = data.imgBase64;
    },
    langChange() {
      this.$store.commit('core/SET_LOCALE', this.loginForm.locale)
      this.$i18n.locale = this.loginForm.locale
      this.$router.go(0)
    }
  },
  async created() {
    this.loginForm.locale = this.$store.state.core.i18n.locale

    let data = await this.$http('sysConfigService.getWebConfig')
    this.$store.commit('core/INIT_SYS_CONFIG', data)
    this.$store.commit('wallpaper/INIT_CONFIG', data)
    document.title = this.$store.getters['core/getAppName']

    this.createCode();
  }
}
</script>

<style lang="less" scoped>
.content-box {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-repeat: repeat;
}

.login-form {
  width: 440px;
  height: 300px;
  background-color: #fff;
  padding: 20px;
  border: 2px solid darkgrey;
  border-radius: 5px;
}

.title {
  font-size: 22px;
  color: darkslategray;
  text-align: center;
  font-weight: bold;
  padding-bottom: 10px;
}

.code-box {
  text-align: right;
}

.code-img {
  width: 100px;
  display: block;
  height: 40px;
  float: right;
  cursor: pointer;
}

.login-btn {
  width: 100%;
}

.lang {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 120px;
}
</style>
